import { Button } from '@toolbox/components';
import { useNavContext } from '@widget/core';
import { omit } from '@toolbox/utils';

import type { ButtonProps } from '@toolbox/components';
import type React from 'react';

type NavBackProps = { back: true; next?: false };
type NavNextProps = { next: true; back?: false };

export type NavButtonProps = (NavBackProps | NavNextProps) & ButtonProps;

export const NavButton = (props: NavButtonProps): JSX.Element => {
  const nav = useNavContext();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault();

    if ((props as NavBackProps).back) {
      nav.back();
    } else if ((props as NavNextProps).next) {
      nav.next();
    }

    props.onClick?.(event);
  };

  return <Button type="button" {...omit(props, ['next', 'back'])} onClick={handleClick} />;
};
